import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class AttrCompreApi extends basicBaseApi {
    public get ControllerName(): any {
        return 'attrCompre'
    }


    public getAttrCompre(unitId,subentryId,roadId,projectDataId,instancetionId){
      return this.send({unitId:unitId,subentryId:subentryId,roadId:roadId,projectDataId:projectDataId,instancetionId:instancetionId},"getAttrCompre",Methods.GET)
    }
    public findDataCalcMoney(subentryId,instancetionId){
      return this.send({subentryId:subentryId,instancetionId:instancetionId},"findDataCalcMoney",Methods.GET)
    }
   

}